import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";

const Banking = () => {
  return (
    <div>
      <AdminHeader />
      <AdminNavbar />
      <div className="commision h-auto fixed_width  bg-[#f0ece1]  ">
        <div className="flex-col flex justify-center ">
          <h2 className="font-bold mt-4  text-black px-[40px]">Check Result</h2>
          <div className="flex  justify-center">
            <div className="commision_bos mt-4   w-[100%] px-5 py-3">
              <input
                type="text"
                className="w-[270px] border-1 border-gray-400 py-2"
                placeholder="User Id "
              />
              <button className="bg-yellow-500 mr-2 rounded text-black font-bold py-1 px-3">
                Search
              </button>
              <label htmlFor="" className="mr-2">
                Status
              </label>
              <select
                name=""
                id=""
                className="w-[120px] py-2  border-1 border-gray-400"
              >
                <option value="">Active</option>
                <option value="">Suspend</option>
                <option value="">Locked</option>
                <option value="">All</option>
              </select>
              <div className="commision_bos  flex items-center mt-4 bg-[#dcf1fdc9] border-b-2 shadow-sm border-blue-300 w-[98%] px-5 py-2">
                <span className=" border-r-1 font-bold text-gray-500  border-gray-400 pr-2">
                  Your Balance
                </span>
                <span className="ml-3 ">PBU</span>{" "}
                <div className="font-bold text-[25px] ml-2">17.68</div>
              </div>
              <div className="main_div  mt-2">
                <div className="flex">
                  <div className=" py-2 w-[37%]  ">
                    <table className=" py-2 w-full border-blue-300  border-r-2 border-b-2 shadow-sm">
                      <thead className=" py-2 bg-gray-200 bg-[#c6ebffc9] border-t-2 border-b-2 shadow-sm border-blue-300 ">
                        <tr>
                          <th
                            className=" text-[14px] py-2 pl-2 w-2/5"
                            colspan="2"
                          >
                            UID
                          </th>
                          <th className=" text-[14px]  py-2 w-1/5">Balance</th>
                          <th className=" py-2 w-1/5 text-[14px]">
                            Available D/W
                          </th>
                          <th className=" text-[14px] py-2 w-1/5 pr-2 text-right">
                            Exposure
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...Array(67)].map((ele, index) => {
                          const count = index + 1;
                          return (
                            <tr className=" bg-[#fff] border-b-2 border-gray-200">
                              <td className=" py-2 pl-2 w-1/5" colspan="2">
                                <span className="mr-1">{count}</span> simul11
                              </td>
                              <td className="  py-2 w-1/5">0.00</td>
                              <td className=" text-right py-2 w-1/5">0.00</td>
                              <td className=" text-right py-2 w-1/5 pr-2">
                                0.00
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className=" py-2 w-[22%]  ">
                    <table className=" py-2 w-full border-blue-300  border-r-2 border-b-2 shadow-sm">
                      <thead className=" py-2 bg-gray-200 bg-[#c6ebffc9] border-t-2 border-b-2 shadow-sm border-blue-300 ">
                        <tr>
                          <th className=" text-[14px] py-2 text-center w-1/5">
                            Deposit / Withdraw{" "}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...Array(67)].map((ele, index) => {
                          return (
                            <tr className=" bg-[#fff] border-b-2 border-gray-200">
                              <td
                                className=" py-1 pl-2 text-center w-[15%]"
                                colspan="2"
                              >
                                <span className="w-[50px] font-bold border-1 mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]">
                                  D
                                </span>
                                <span className="w-[50px] font-bold border-1 mr-2 hover:shadow-md cursor-pointer hover:bg-gray-200 bg-gray-100 border-gray-300 px-2 py-[5px]">
                                  W
                                </span>
                                <input
                                  type="text"
                                  className="text-right w-[150px] font-bold text-gray-500 pr-2 border-gray-400 border-1 mr-2 py-[6.223px] cursor-pointer"
                                  value="0"
                                  readonly
                                />
                                <span className="py-1 px-2 rounded bg-gray-200 font-bold text-gray-500 pr-2 border-gray-400 border-1">
                                  Full
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className=" py-2 w-[22%]  ">
                    <table className=" py-2 w-full border-blue-300  border-r-2 border-b-2 shadow-sm">
                      <thead className=" py-2 bg-gray-200 bg-[#c6ebffc9] border-t-2 border-b-2 shadow-sm border-blue-300 ">
                        <tr>
                          <th className=" text-[14px] py-2 text-center w-1/5 ">
                            Credit Reference
                          </th>
                          <th className=" text-[14px] py-2 text-right w-1/5 ">
                            Reference P/L
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...Array(67)].map((ele, index) => {
                          const count = index + 1;
                          return (
                            <tr className=" bg-[#fff] border-b-2 border-gray-200">
                              <td
                                className=" py-2 pl-2  text-center  w-[10%]"
                                colspan="1"
                              >
                                <a href="#" className="text-blue-500 underline">
                                  {count}
                                </a>
                                <span className="py-1 px-2 ml-2  rounded bg-gray-200 font-bold text-black pr-2 border-gray-400 border-1">
                                  Edit
                                </span>
                              </td>
                              <td
                                className=" py-2 pr-3 text-right w-[10%]"
                                colspan="1"
                              >
                                0.00
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                  <div className=" py-2 w-[20%]  ">
                    <table className=" py-2 w-full border-blue-300  border-r-2 border-b-2 shadow-sm">
                      <thead className=" py-2 bg-gray-200 bg-[#c6ebffc9] border-t-2 border-b-2 shadow-sm border-blue-300 ">
                        <tr>
                          <th className=" text-[14px] py-2 text-right w-1/5 ">
                            Remakrs
                          </th>
                          <th className=" ml-2 text-[14px] py-2 text-left w-1/5 ">
                            Logs
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {[...Array(67)].map((ele, index) => {
                          const count = index + 1;
                          return (
                            <tr className=" bg-[#fff] border-b-2 border-gray-200">
                              <td
                                className=" py-2 pl-2  text-center  w-[10%]"
                                colspan="1"
                              >
                                <input
                                  type="text"
                                  className="w-[120px] text-right pr-2  border-1 py-[5px] border-gray-400"
                                  placeholder="Remarks"
                                />
                              </td>
                              <td
                                className=" py-2 pr-3 text-right w-[10%]"
                                colspan="1"
                              >
                                0.00
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banking;
